import dynamic, { DynamicOptions } from 'next/dynamic'
import { logger } from '@/utils/logging'
import { GuildHeroCTAProps } from './GuildHeroCTA'

export const GuildHeroCTA = dynamic(
  import('./GuildHeroCTA')
    .then((mod) => mod.GuildHeroCTA)
    .catch((err) =>
      logger().error('Failed to load dynamic component', { component: 'GuildHeroCTA' }, err),
    ) as DynamicOptions<GuildHeroCTAProps>,
  { ssr: false },
)
